import React, { useContext } from "react";
import "./shared.scss";
import Page from "pages/Page";
import { PageLayout, TopSection, useTranslator } from "@sia/style-guide";
import SideBarWithLinks from "components/SideBarWithLinks";
import GlobalContext from "contexts/GlobalContext";

export default function HeaderView({ tabs, selectedTab, setSelectedTab, history }) {
  const { language } = useContext(GlobalContext);
  const translate = useTranslator();
  const pageTitle = translate("benchmarking.evaluations.header.title");

  return (
    <Page
      className="landing"
      title={pageTitle}
    >
      <PageLayout variant="layout_25_50_25">
        <div></div>
        <div className="center" lang={language}>
          <h2 className="sia-text-12">{pageTitle}</h2>
          <div className="sia-text-04 sia-padding-01-bottom Localized-Text">{translate("benchmarking.evaluations.header.first-paragraph")}</div>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">{translate("benchmarking.evaluations.header.second-paragraph")}</div>
        </div>
        <div className={`right-column ${pageTitle.length > 39 ? "double-height-title" : ""}`}>
          <SideBarWithLinks />
        </div>
      </PageLayout>
      <div className={`section-container`}>
        <div className="section-content sia-padding-02-left sia-padding-02-right">
          <TopSection item={{}} array={tabs} selected={selectedTab} setSelected={setSelectedTab} history={history} stopNavigation />
        </div>
      </div>
    </Page>
  );
}
